/**
 * @generated SignedSource<<cc23da3e846511f5a09e4b9395391b27>>
 * @relayHash a6568b2c61bc9da4ae570ce3d0fe8530
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3327c6440fe945dd33b925cc77ef3490a177bfd275e3c2cbb057035db0d79491

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraBoardSwimlaneStrategy = "ASSIGNEE_UNASSIGNED_FIRST" | "ASSIGNEE_UNASSIGNED_LAST" | "CUSTOM" | "EPIC" | "ISSUE_CHILDREN" | "ISSUE_PARENT" | "NONE" | "PARENT_CHILD" | "PROJECT" | "REQUEST_TYPE" | "%future added value";
export type JiraIssueSearchOperationScope = "NIN_GLOBAL" | "NIN_GLOBAL_SCHEMA_REFACTOR" | "NIN_GLOBAL_SHADOW_REQUEST" | "NIN_PROJECT" | "NIN_PROJECT_SCHEMA_REFACTOR" | "NIN_PROJECT_SHADOW_REQUEST" | "TIMELINE_PROJECT" | "%future added value";
export type JiraJqlViewContext = "JPD_ROADMAPS" | "JSM_QUEUE_PAGE" | "JSM_SUMMARY_PAGE" | "JSW_PLANS" | "JSW_SUMMARY_PAGE" | "JWM" | "SHADOW_REQUEST" | "%future added value";
export type JiraJqlScopeInput = {
  backlog?: JiraJqlBacklogInput | null | undefined;
  board?: JiraJqlBoardInput | null | undefined;
  list?: JiraIssueSearchScope | null | undefined;
  plan?: JiraJqlPlanInput | null | undefined;
};
export type JiraJqlBacklogInput = {
  boardId: AGG$Long;
};
export type JiraJqlBoardInput = {
  boardId: AGG$Long;
  swimlaneStrategy?: JiraBoardSwimlaneStrategy | null | undefined;
};
export type JiraIssueSearchScope = {
  operationScope?: JiraIssueSearchOperationScope | null | undefined;
  projectKey?: string | null | undefined;
};
export type JiraJqlPlanInput = {
  planId: AGG$Long;
  scenarioId?: AGG$Long | null | undefined;
};
export type getIssueTypeProps216BadPatternQuery$variables = {
  after?: string | null | undefined;
  cloudId: string;
  first?: number | null | undefined;
  jql: string;
  jqlTerm: string;
  scope?: JiraJqlScopeInput | null | undefined;
  searchString: string;
  viewContext?: JiraJqlViewContext | null | undefined;
};
export type getIssueTypeProps216BadPatternQuery$data = {
  readonly jira: {
    readonly jqlBuilder: {
      readonly fieldValues: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly displayName: string;
            readonly issueTypes?: ReadonlyArray<{
              readonly avatar: {
                readonly xsmall: string | null | undefined;
              } | null | undefined;
            }>;
            readonly jqlTerm: string;
          } | null | undefined;
        } | null | undefined> | null | undefined;
        readonly pageInfo: {
          readonly endCursor: string | null | undefined;
        };
        readonly totalCount: number | null | undefined;
      } | null | undefined;
    } | null | undefined;
  };
};
export type getIssueTypeProps216BadPatternQuery = {
  response: getIssueTypeProps216BadPatternQuery$data;
  variables: getIssueTypeProps216BadPatternQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": 10,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jql"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jqlTerm"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scope"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchString"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewContext"
},
v8 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v9 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "jqlContext",
    "variableName": "jql"
  },
  {
    "kind": "Variable",
    "name": "jqlTerm",
    "variableName": "jqlTerm"
  },
  {
    "kind": "Variable",
    "name": "scope",
    "variableName": "scope"
  },
  {
    "kind": "Variable",
    "name": "searchString",
    "variableName": "searchString"
  },
  {
    "kind": "Variable",
    "name": "viewContext",
    "variableName": "viewContext"
  }
],
v10 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v11 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    }
  ]
},
v12 = {
  "kind": "ScalarField",
  "name": "jqlTerm"
},
v13 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v14 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "xsmall"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "name": "getIssueTypeProps216BadPatternQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": (v8/*: any*/),
              "concreteType": "JiraJqlBuilder",
              "kind": "LinkedField",
              "name": "jqlBuilder",
              "plural": false,
              "selections": [
                {
                  "args": (v9/*: any*/),
                  "concreteType": "JiraJqlFieldValueConnection",
                  "kind": "LinkedField",
                  "name": "fieldValues",
                  "plural": false,
                  "selections": [
                    (v10/*: any*/),
                    (v11/*: any*/),
                    {
                      "concreteType": "JiraJqlFieldValueEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v12/*: any*/),
                            (v13/*: any*/),
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraIssueType",
                                  "kind": "LinkedField",
                                  "name": "issueTypes",
                                  "plural": true,
                                  "selections": [
                                    (v14/*: any*/)
                                  ]
                                }
                              ],
                              "type": "JiraJqlIssueTypeFieldValue"
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v6/*: any*/),
      (v0/*: any*/),
      (v7/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "getIssueTypeProps216BadPatternQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v8/*: any*/),
            "concreteType": "JiraJqlBuilder",
            "kind": "LinkedField",
            "name": "jqlBuilder",
            "plural": false,
            "selections": [
              {
                "args": (v9/*: any*/),
                "concreteType": "JiraJqlFieldValueConnection",
                "kind": "LinkedField",
                "name": "fieldValues",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  (v11/*: any*/),
                  {
                    "concreteType": "JiraJqlFieldValueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__typename"
                          },
                          (v12/*: any*/),
                          (v13/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueTypes",
                                "plural": true,
                                "selections": [
                                  (v14/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "id"
                                  }
                                ]
                              }
                            ],
                            "type": "JiraJqlIssueTypeFieldValue"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "3327c6440fe945dd33b925cc77ef3490a177bfd275e3c2cbb057035db0d79491",
    "metadata": {},
    "name": "getIssueTypeProps216BadPatternQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "07b74dfb3270c802a2aedf91e062e75d";

export default node;
